import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import {
  TransitionDependentEnrollmentToEnrolledInput,
  TransitionDependentEnrollmentToEnrolledPayload,
} from "@oysterhr/schema"

const ENROLL_ENROLLMENT_MUTATION = gql`
  mutation StaffBenefitsTransitionDependentEnrollmentToEnrolled(
    $input: TransitionDependentEnrollmentToEnrolledInput!
  ) {
    transitionDependentEnrollmentToEnrolled(input: $input) {
      errors
      dependentEnrollment {
        id
        state
        coverageStartDate
        pricePaidProvider {
          formatted
        }
        enrollment {
          totalPrice {
            formatted
          }
          totalPriceInvoicedCompany {
            formatted
          }
        }
      }
    }
  }
`
interface _MutationPayload {
  transitionDependentEnrollmentToEnrolled: TransitionDependentEnrollmentToEnrolledPayload
}

interface _MutationInput {
  input: TransitionDependentEnrollmentToEnrolledInput
}

export const useTransitionDependentEnrollmentToEnrolled = (
  options?: InjectedOptions<_MutationPayload, _MutationInput>,
) => {
  return useMutation<_MutationPayload, _MutationInput>(ENROLL_ENROLLMENT_MUTATION, {
    ...options,
  })
}
